import React, { Component } from 'react';
import { Table } from 'antd';
import UpdateScore from './UpdateScore';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import Sider from '../SumEffSider';
import Filter from './Filter';

class CrcQuarterScore extends Component {
    state = {
        searchParams: {},
        pagination: {
            current: 1,
            pageSize: 15,
        },
        data: [],
        isEdit: false,
        loading: false,
    }

    loadData = () => {
        this.setState({ loading: true });
        const { searchParams, pagination, pagination: { current, pageSize } } = this.state;
        const options = {
            url: `${API_URL.sumtotal.queryCrcQuarterScore}`,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { isEdit, data: { datas = [], totalCount = 0 } } = res;
                pagination.total = totalCount;
                this.setState({
                    isEdit,
                    pagination,
                    data: datas,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: {...params},
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { pagination, searchParams } =  this.state;
        ExportUtil.export(searchParams, pagination, API_URL.sumtotal.exportCrcQuarterScore);
    }

    getColumns = () => ([
        {
            title: '考核时间',
            dataIndex: 'date',
            fixed: 'left',
            width: 130,
        }, {
            title: 'CRC姓名',
            dataIndex: 'userCompellation',
            fixed: 'left',
            width: 90,
        }, {
            title: 'CRC工号',
            dataIndex: 'employeeCode',
            fixed: 'left',
            width: 90,
        }, {
            title: '当季度平均FTE',
            dataIndex: 'fteValue',
            fixed: 'left',
            width: 105,
        }, {
            title: '启动贡献度',
            dataIndex: '1',
        }, {
            title: '筛选贡献度',
            dataIndex: '2',
        }, {
            title: '入组贡献度',
            dataIndex: '3',
        }, {
            title: '数据录入进度质量贡献度',
            dataIndex: '14',
        }, {
            title: '安全性管理贡献度',
            dataIndex: '15',
        }, {
            title: '中心质量贡献度',
            dataIndex: '4',
        }, {
            title: '日常反馈和周报等及时准确度',
            dataIndex: '16',
        }, {
            title: '方案及流程熟悉程度',
            dataIndex: '17',
        }, {
            title: '积极分享，担任PA模块负责人等',
            dataIndex: '18',
        }, {
            title: '快速学习，正向思考，积极行动，使命必达，乐于助人',
            dataIndex: '19',
        }, {
            title: '研究者/其他中心人员反馈',
            dataIndex: '20',
        }, {
            title: '总计得分',
            dataIndex: 'total',
        }, {
            title: 'PM总结性评语',
            dataIndex: 'pmComment',
            width: 240,
        }, {
            title: '操作',
            dataIndex: 'operate',
            fixed: 'right',
            width: 85,
            render: (text, record) => {
                const { isEdit } = this.state;
                return <a onClick={() => this.updateScore(record)}>{isEdit ? '评分' : '查看'}</a>
            }
        },
    ])

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map(item => {
            const params = { ...item };
            const { year, startMonth, endMonth, performancePmCrcScoreDetails = [] } = item || {};
            params.date = `${year}-${startMonth < 10 ? `0${startMonth}`: startMonth}~${year}-${endMonth < 10 ? `0${endMonth}`: endMonth}`;
            performancePmCrcScoreDetails.forEach(i => {
                params[i.relatedId] = i.scoreValue;
            });
            return params;
        });
        return dataSource;
    }

    handleTableChange = (pagination) => {
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    updateScore = (record = {}) => {
        const { searchParams: { startDate = null, endDate = null } } = this.state;
        this.UpdateScoreRef.show({
            ...record,
            startDate,
            endDate,
        });
    }

    render() { 
        const { isEdit, loading, pagination } = this.state;
        return (
            <div className="content">
                <Sider selectKey='crcQuarterScore' />
                <div className="main">
                    <Filter
                        search={this.search}
                        export={this.export}
                    />
                    <div className="main-content">
                        <Table
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.userId}
                            loading={loading}
                            scroll={{x: 2400}}
                            onChange={this.handleTableChange}
                            pagination={ pagination }
                        />
                    </div>
                    <UpdateScore isEdit={isEdit} loadData={this.loadData} ref={el => this.UpdateScoreRef = el} />
                </div>
            </div>
        );
    }
}

export default CrcQuarterScore;


// WEBPACK FOOTER //
// ./src/components/sumTotal/crcQuarterScore/index.js